import * as angular from 'angular';

import { ComponentDefinition } from '../../models';

class ApprovalLevelPickerController implements angular.IComponentController {
    static $inject = [];
}

export const wtApprovalLevelPicker: ComponentDefinition = {
    componentId: 'wtApprovalLevelPicker',
    controller: ApprovalLevelPickerController,
    template: require('./approvalLevelPicker.component.html'),
    controllerAs: 'vm',
    bindings: {
        levels: '<',
        name: '@',
        model: '='
    }
};
